import { IDs } from '../../helpers/IDs';
import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import style from './KontaktAnsprechpartner.less';
import { checkFunktionFuerBereich } from '../../main/functions/checkFunktionFuerBereich';

export interface KontakteAnsprechpartnerProps {
    data: any;
}

export class KontakteAnsprechpartner extends React.Component<KontakteAnsprechpartnerProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        const bereich_key: string = (((this.props.data || {})[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig;
        const showKarte = checkFunktionFuerBereich('KontakteAnsprechpartner_Karte', bereich_key);
        return (
            <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                {showKarte && <div style={{ display: 'flex', flexDirection: 'column', flex: 1, maxWidth: 1010 }}>
                    <iframe
                        style={{ flex: 1 }}
                        src='https://www.google.com/maps/d/embed?mid=1uwuJJPdl-H3Vn-K-hCug9pEn7nlA1KZ0&ll=51.37777611440162%2C12.440602814320421&z=6'
                    />
                </div>}
                <div className={style.wrapper} style={{ padding: 20, flex: 1 }}>
                    {renderText('Ansprechpartner:in', this.props.data)}
                </div>
            </div>
        );
    }
}
